'use strict';

var GetIntrinsic$1 = require('../GetIntrinsic.js');
require('./callBind.js');
var callBind$1 = require('../../../../../_virtual/callBind.js_commonjs-module.js');

var GetIntrinsic = GetIntrinsic$1;

var callBind = callBind$1.callBind.exports;

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

module.exports = callBound;
